import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import { fragment } from 'ember-data-model-fragments/attributes';
import type BadgeBadge from '@linc-technologies/linced-common/models/goals/badge-badge';
import type BadgeRecipient from '@linc-technologies/linced-common/models/goals/badge-recipient';
import type BadgeVerification from '@linc-technologies/linced-common/models/goals/badge-verification';

// Proto: goals.BadgeAssertion.
export default class BadgeAssertion extends Fragment {
  declare [Type]: 'goals/badge-assertion';

  // Relevant JSON-LD context for the Open Badges Specification.
  // https://w3id.org/openbadges/v2
  @attr('string', { defaultValue: '' })
  declare context: string;

  // Unique IRI for the Assertion.
  // If using hosted verification, this should be the URI where the assertion i
  // s accessible.
  // For signed Assertions, it is recommended to use a UUID in the urn:uuid
  // namespace.
  // "https://example.org/assertions/123"
  @attr('string')
  declare assertionId: string | undefined;

  // Valid JSON-LD representation of the Assertion type.
  // In most cases, this will simply be the string "Assertion".
  // "Assertion"
  @attr('string', { defaultValue: '' })
  declare type: string;

  // The recipient of the achievement.
  @fragment('goals/badge-recipient')
  declare recipient: BadgeRecipient | null;

  // Describes the type of badge being awarded.
  @fragment('goals/badge-badge')
  declare badge: BadgeBadge | null;

  // Instructions for third parties to verify this assertion.
  @fragment('goals/badge-verification')
  declare verification: BadgeVerification | null;

  // Timestamp of when the achievement was awarded.
  // "2016-12-31T23:59:59+00:00"
  @attr('string', { defaultValue: '' })
  declare issuedOn: string;
}
